import { motion } from "framer-motion";
import Parallax_Images from "../Parallax_Images";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Layout from "../Layout";
import { Link } from "react-router-dom";

const Homepage = () => {
  const [text] = useTypewriter({
    words: [
      "a UI/UX Designer ",
      "a Front-End Developer",
      "a Wordpress designer",
      "a web developer",
      "a Digital Artist",
      "an Army Officer",
      "a leader",
    ],
    loop: true,
    typeSpeed: 115,
    deleteSpeed: 100,
    delaySpeed: 1500,
  });

  const fadeInUp = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
  };

  return (
    <Layout>
      <main className="homepage-main">
        <div className="container">
          <motion.div
            initial="initial"
            animate="animate"
            variants={fadeInUp}
            transition={{ duration: 1.5 }}
          >
            <h1 className="home-header intro-main">
              <u
                style={{
                  borderBottom: "3px solid #ffffffff",
                  textDecoration: "none",
                }}
              >
                Hello there!{" "}
                <span
                  style={{ color: "#933538", fontFamily: "'fraunces', serif" }}
                >
                  {" "}
                  I'm Sabrina{" "}
                </span>
              </u>
            </h1>
          </motion.div>

          <motion.div
            initial="initial"
            animate="animate"
            variants={fadeInUp}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <h1 className="home-header intro-sub">
              I am <span className="typed-text">{text}</span>
              <Cursor cursorStyle="|" cursorClassName="typed-cursor" />
            </h1>
          </motion.div>

          <motion.div
            className="cta-section"
            initial="initial"
            animate="animate"
            variants={fadeInUp}
            transition={{ duration: 1, delay: 1 }}
          >
            <p className="cta-subtext">check out my work</p>
            <div className="cta-buttons">
              <Link to="/art" className="cta-btn">
                Art Gallery
              </Link>
              <Link to="/cs" className="cta-btn">
                Tech Projects
              </Link>
            </div>
          </motion.div>
        </div>

        <Parallax_Images />
      </main>
    </Layout>
  );
};

export default Homepage;
